import React from "react";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import { FormTextField } from "./FormTextField";
import { ControlledFileInput } from "./ControlledFileInput";
import { StepContentProps } from "./BusinessInfoTypes";
import { Box } from "@mui/material";
import { useThemeMode } from "../../contexts/ThemeModeContext";

/**
 * Step 4: Communication Portal Info
 */
export const StepPortalInfo: React.FC<StepContentProps> = ({
  formData,
  setFormData,
}) => {
  const { mode } = useThemeMode();
  return (
    <div className="space-y-4">
      <Typography
        variant="h5"
        component="h2"
        sx={{ mt: 3, mb: 3 }}
        className="!mb-4 text-gray-700"
      >
        4. CoreSupport Portal Information
      </Typography>

      {/* CoreSupport Info */}
      <Box
        sx={{
          p: 3,
          borderRadius: "20px",
          border: mode === "dark" ? "1px solid #374151" : " 1px solid #e5e7eb", // adjust colors if needed
        }}
      >
        <FormTextField
          label="Information for CoreSupport Team (e.g., key contacts, preferred communication times) (Optional)"
          value={formData.coreSupportInfo || ""}
          multiline
          rows={5}
          onChange={(value) =>
            setFormData((prev) => ({
              ...prev,
              coreSupportInfo: value,
            }))
          }
        />

        {/* Upload Files */}
        <Stack sx={{ pt: 2 }}>
          <Typography
            variant="subtitle1"
            component="h3"
            sx={{ mb: 1, fontWeight: "medium" }}
          >
            Upload General Documentation (Optional)
          </Typography>

          <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
            Attach any relevant general documents (e.g., organization chart,
            brand guidelines, internal processes).
          </Typography>

          <ControlledFileInput
            label="Choose General Documents"
            multiple
            value={formData.generalDocuments || null}
            folderPath="/Business_info/portal_info"
            onChange={(files) =>
              setFormData((prev) => ({
                ...prev,
                generalDocuments: files,
              }))
            }
          />
        </Stack>
      </Box>
    </div>
  );
};
